import {
    ApiQueryData,
    ProductVariantResponse
} from '../interfaces';
import axios, { AxiosResponse } from 'axios';
import {PARAM_PAGE} from '../constants';

export interface ProductVariantService {
    setDefaultQueryObject(defaultQueryObject: ApiQueryData): void;

    getData(apiQueryData: ApiQueryData): Promise<ProductVariantResponse>;
}

class ProductVariantService implements ProductVariantService {
    private defaultQueryObject: ApiQueryData;

    setDefaultQueryObject = (defaultQueryObject: ApiQueryData): void => {
        this.defaultQueryObject = defaultQueryObject;
    }

    getDefaultQueryObject = (): ApiQueryData => this.defaultQueryObject;

    getData = async(apiQueryData: ApiQueryData): Promise<ProductVariantResponse> => {
        const regex = /\/\d+$/;
        const apiUrlElement: HTMLElement = document.querySelector('[data-product-all-variants-api-url]');
        const apiUrl = apiUrlElement.dataset.productAllVariantsApiUrl;
        const apiUrlObject = new URL(apiUrl, window.location.origin);
        const variantApiUrl = apiUrlObject.origin + apiUrlObject.pathname.replace(regex, '');

        const dataResponse = await axios.get(`${variantApiUrl}` + '/' + `${apiQueryData[PARAM_PAGE]}`);

        return dataResponse.data;
    }
}

export const productVariantService = new ProductVariantService();
